<template>
  <b-modal
    ref="modal"
    size="xl"
    class="text-left font_Montserrat"
    centered
    :visible="visible"
    ok-only
    @hidden="onModalHidden"
  >
    <template slot="modal-header" v-if="title">
      <div class="w-100">
        <h5 class="modal-title v2_info-popup__title">
          <span>{{ title }}</span>
        </h5>
      </div>
    </template>

    <div class="my-4">
      <div class="text-left question-text">
        <div v-if="token" class="d-flex align-items-center">
          <a :href="link" target="_blank">
            {{ link }}
          </a>
          <b-button
            v-if="isClipboardSupported()"
            size="sm"
            variant="info"
            @click="copyLink"
            class="ml-2 px-2 py-1"
          >
            <i
              class="mdi mdi-clipboard-text-multiple v2_font_size_12"
              aria-hidden="true"
            />
          </b-button>
        </div>
        <span v-else>No registration link</span>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'RegistrationTokenModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    token: {
      validator: (prop) => typeof prop === 'string' || prop === null,
    },
  },
  computed: {
    link: function () {
      return `${window.location.origin}/#/sign-up/${this.token}`;
    },
  },
  methods: {
    onModalHidden: function () {
      this.$emit('modal-close');
    },
    copyLink: function () {
      if (!this.isClipboardSupported()) return;
      navigator.clipboard.writeText(this.link);
      this.$toasted.success('Link copied successfully.', { duration: 3000 });
    },
    isClipboardSupported: function () {
      return (
        navigator &&
        navigator.clipboard &&
        typeof navigator.clipboard.writeText === 'function'
      );
    },
  },
};
</script>

<style scoped />
